import Swal from 'sweetalert2';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { EventService } from 'src/app/Service/event.service';
import { faChevronCircleDown } from '@fortawesome/free-solid-svg-icons';
import { faChevronCircleUp } from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { GenerateCsvService } from 'src/app/Service/generate-csv.service';
import { Constants } from 'src/assets/Constats';
import { SelectionModel } from '@angular/cdk/collections';
import { NgOption } from '@ng-select/ng-select';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SharedConstants } from 'src/app/models/shared/shared.constants';
import { AuthService } from 'src/app/Service/auth.service';
import { CompanyService } from 'src/app/Service/company-service.service';
import { EnumUserRol } from 'src/app/models/shared/app-enums';
import { ContractService } from 'src/app/Service/contract.service';
import { utilsApps } from 'src/app/helpers/utils-app';
import { ErrorCustomService } from 'src/app/Service/error-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { PaginationTableService } from '../../shared/pagination/pagination-table/pagination-table.service';
import { ClientService } from 'src/app/Service/client.service';
import { RecordAdapterService } from '../record/Service/record-adapter.service';

export interface IFilterSearch {
  companyId: string,
  companyApiKey: string,
  branchId: string,
  name: string | null,
  userId: string,
  statusId: number,
  dateInitFormated: string,
  dateEndFormated: string
}

export interface ICatCompany {
  companyId: string,
  companyApiKey: string,
  description: string
}

@Component({
  selector: 'app-list-documents',
  templateUrl: './list-documents.component.html',
  styleUrls: ['./list-documents.component.scss'],
})

export class ListDocumentsComponent implements OnInit, OnDestroy {
  settingsFile = './assets/model/data.json';
  dataResult = <any>[];
  startDate = '';
  endDate = '';
  filterpost = '';
  q: number = 1;

  classInputSearch = "col-lg-2 col-md-2 col-sm-12";
  classDivAux = "col-lg-1 col-md-1 col-sm-0";

  catStatus = [
    { isChecked: false, id: -1, description: 'Todos', keyLg: "All" },
    { isChecked: false, id: 0, description: 'N/A', keyLg: "NA" },
    { isChecked: false, id: 1, description: 'Exitoso', keyLg: "Success" },
    { isChecked: false, id: 2, description: 'En Revisión', keyLg: "InReview" },
    { isChecked: false, id: 3, description: 'Rechazado', keyLg: "Reject" },
  ];

  selected?: number;
  dataArrayCopy = <any>[];
  //Icons

  Icon_Down = faChevronCircleDown;
  Icon_Download = faDownload;
  Icon_Up = faChevronCircleUp;
  //Variables
  dataInformation = <any>[];
  dataInformationOrigin = <any>[];
  selectAllCheck: boolean = false;
  loadPage: boolean = false;
  data: any;
  options: any;
  documentType: string;
  id: string;
  type = 'doughnut';
  ordened: any = 0;
  resetTable = false;
  rowCount = 5;
  totalItems: number;
  rotate = true;
  selection = new SelectionModel<any>(true, []);
  process: NgOption[];
  errorDocument: string;
  documentName: string;
  url: string;
  showDdlCompany: boolean = false;

  /** Variables of pagination */
  protected totalPages: any[] = [];
  protected currentPage: number = 1;

  dataChart: any;

  emptyDataList: boolean = true;
  msgDataEmpty: string = 'No encontramos resultados. Ingresa una nueva búsqueda';
  IsPostBack = false;

  validFileTypes = [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];
  fileInfoBase64: any;
  fileInfo: any;

  fmFilters = this.fb.group({
    ddlCompany: [''],
    txtSearch: [''],
    ddlStatus: [''],
    ddlBranch: [''],
    txtDateInit: [new Date(), [Validators.required]],
    txtDateEnd: [new Date(), [Validators.required]],
  });

  selectedImageModal: any;
  detail: string;
  modalRef: BsModalRef;
  modalConfig = {
    backdrop: true,
    ignoreBackdropClick: false,
    keyboard: false,
    class: '',
  };
  componentForm: FormGroup;
  regexPattern: string;
  branches: NgOption[] = [];
  catUsers: NgOption[] = [];
  catCompany: ICatCompany[] = [];
  waitFor = false;

  branchId: string;
  userId: string;
  companyId: string;
  currentUser: any;
  currentCompanyId: string;
  currentBranchId: string;
  currentApiKey: string;

  currentFilter: IFilterSearch = {
    companyId: '',
    branchId: '',
    companyApiKey: '',
    name: null,
    userId: '',
    statusId: -1,
    dateEndFormated: '',
    dateInitFormated: ''
  };


  private userData: any;
  private readonly idCompany: number;
  private readonly _companyFilter: string;

  private readonly httpClient: HttpClient;
  get f() {
    return this.fmFilters.controls;
  }

  showBtnDelete: boolean;
  showItemExpedient: boolean;
  showItemContract: boolean;
  showItemManualValidation: boolean;

  /** For delete any enrollment */
  private msg_confirmDelete: string;
  private btnYes: string;
  private btnCancel: string;

  protected showModalDialogManualValid: boolean = false;
  protected idClientManualValid: number = -1;

  constructor(
    private readonly http: HttpClient,
    private readonly handler: HttpBackend,
    private readonly generateDocument: GenerateCsvService,
    private readonly router: Router,
    protected eventService: EventService,
    private readonly fb: FormBuilder,
    private readonly fb2: FormBuilder,
    private readonly _service: CompanyService,
    private readonly authService: AuthService,
    private readonly _errorS: ErrorCustomService,
    private readonly _contractS: ContractService,
    private readonly modalService: BsModalService,
    private readonly _modalService: NgbModal,
    private readonly translate: TranslateService,
    private readonly sharedConstants: SharedConstants,
    private readonly paginationTableService: PaginationTableService,
    private readonly clientService: ClientService,
    private readonly recordAdapterService: RecordAdapterService,
  ) {

    this._modalService.dismissAll();
    let _util = new utilsApps();
    _util.disableBack();

    this.authService.currentUser.subscribe(resp => {

      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;

      if (this.currentUser.roles[0].id == EnumUserRol.SUPER_ADMIN) {
        this.showDdlCompany = true;
      }

      if (this.currentUser.roles[0].id == EnumUserRol.SUPER_ADMIN
        || this.currentUser.roles[0].id == EnumUserRol.ADMIN
        || this.currentUser.roles[0].id == EnumUserRol.USER
      ) {
        this.showBtnDelete = true;
        this.showItemExpedient = true;
        this.showItemContract = true;
      }
      else if (this.currentUser.roles[0].id == EnumUserRol.RRHH) {
        this.showItemContract = true;
      }

      this.showItemManualValidation = !this.showDdlCompany && this.currentUser.roles[0].id != EnumUserRol.EXECUTIVE;

      this.classInputSearch = this.showDdlCompany ? "col-lg-2 col-md-2 col-sm-12" : "col-lg-3 col-md-3 col-sm-12";
      if (this.showDdlCompany) {
        this.classDivAux = "col-lg-0 col-md-0 col-sm-0";
      }
    });

    this.loadPage = false;
    this.httpClient = new HttpClient(handler);
    this.regexPattern = this.sharedConstants.regexPattern.alphanumeric;
    this.userData = JSON.parse(localStorage.getItem('currentUser'));
    this.idCompany = this.userData.branches[0].idCompany;
    this.currentApiKey = this.userData.apiKey;
    this.getDataLanguage();
  }

  getDataLanguage() {
    this.catStatus.forEach(element => {
      this.translate.stream('dashboard.catStatus.' + element.keyLg).subscribe((res: string) => {
        element.description = res;
      });
    });

    this.translate.stream('common.msgEmptyTableGrid').subscribe((res: string) => {
      this.msgDataEmpty = res;
    });

    this.translate.stream('dashboard.gridColumns.lblConfirmDelete').subscribe((res: string) => {
      this.msg_confirmDelete = res;
    });

    this.translate.stream('common.yes').subscribe((res: string) => {
      this.btnYes = res;
    });

    this.translate.stream('common.btnCancel').subscribe((res: string) => {
      this.btnCancel = res;
    });
  }

  getFileDocument(id: string, documentSignType: string) {

    this.waitFor = true;
    this.eventService.startLoadingData();
    try {
      this._contractS.GetPDFFileClient(id, documentSignType).subscribe({
        next: res => {
          console.log(res);
          let _fileName = "ID-" + id;
          let _utils = new utilsApps();
          let _now = new Date();
          console.log(res);
          _utils.downloadFileBlob(res, _fileName + _utils.fnDateToString(_now), ".pdf");
          this.eventService.completeLoadingData();
          this.waitFor = false;
        },
        error: error => {

          let _errorMsj = "Ha ocurrido un error al intentar descargar los datos. Por favor consulte a su administrador.";
          let _errorKey = 'common.error500_download';

          if (error.status == 500) {
            _errorKey = "common.error500_download_file";
          }
          else if (error.status == 0) {
            _errorKey = "common.error0_download";
          }

          this.translate.stream(_errorKey).subscribe((res: string) => {
            console.log(res);
            _errorMsj = res;
          });

          this.eventService.errorMessage(0, _errorMsj);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
      this.waitFor = false;
    }
  }


  getExpedientS(id: string) {
    this.waitFor = true;
    this.eventService.startLoadingData();
    try {
      this._contractS.GetExpedientClient(id, this.currentFilter.companyId).subscribe({
        next: res => {
          //console.log(res);
          let _fileName = "Expediente_" + id;
          let _utils = new utilsApps();
          _utils.downloadFileBlob(res, _fileName, ".pdf");
          this.eventService.completeLoadingData();
          this.waitFor = false;
        },
        error: error => {
          console.log(error);
          let _errorMsj = "Ha ocurrido un error al intentar descargar los datos. Por favor consulte a su administrador.";
          let _errorKey = 'common.error500_download';

          if (error.status == 500) {
            _errorKey = "common.error500_download_file";
          }
          else if (error.status == 0) {
            _errorKey = "common.error0_download";
          }

          this.translate.stream(_errorKey).subscribe((res: string) => {
            console.log(res);
            _errorMsj = res;
          });

          this.eventService.errorMessage(0, _errorMsj);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
      this.waitFor = false;
    }
  }

  onCheckFilterSession() {
    try {
      let _auxCompany = localStorage.getItem("_company");
      let txtDateInit = this.getDateInitMonth();
      let txtDateEnd = new Date();

      //Si ya hay info en el memoria entonces se toma esa
      if (_auxCompany != null) {
        //console.log("Info en localstorage");
        this.currentFilter.companyId = localStorage.getItem("_company");
        this.currentFilter.companyApiKey = localStorage.getItem("f_apikey");
        this.currentFilter.branchId = localStorage.getItem("_branch");
        this.branchId = this.currentFilter.branchId;
        let _searchText = localStorage.getItem("_search");

        if (_searchText != null && _searchText.length > 0 && _searchText != "null") {
          this.currentFilter.name = localStorage.getItem("_search");
        }
        else {
          this.currentFilter.name = null;
        }
        this.currentFilter.dateEndFormated = localStorage.getItem("_dateEndFormated");
        this.currentFilter.dateInitFormated = localStorage.getItem("_dateInitFormated");
        this.currentFilter.statusId = Number.parseInt(localStorage.getItem("_statusId"));
        this.currentFilter.userId = localStorage.getItem("_user");
      }
      else {

        /**
         * Si no hay info en el storage entonces el filtro tendrá la información del
         * usuario en sesión y también se manda al storage
         */

        this.currentFilter.companyId = this.currentUser.branches[0].idCompany;
        this.currentFilter.companyApiKey = this.currentUser.apiKey;
        this.currentFilter.branchId = this.currentUser.branches[0].id;
        this.currentFilter.name = null;
        let dateInitFormated = this.formatDate2(txtDateInit);
        let dateEndFormated = this.formatDate2(txtDateEnd);
        this.currentFilter.dateInitFormated = dateInitFormated;
        this.currentFilter.dateEndFormated = dateEndFormated;
        this.currentFilter.statusId = -1;
        this.currentFilter.userId = "0";

        console.log("this.currentUser", this.currentUser);

        if (this.currentUser.roles[0].id == EnumUserRol.USER) {
          this.currentFilter.userId = this.currentUser.id.toString();
        }

        localStorage.setItem('_dateInitFormated', dateInitFormated);
        localStorage.setItem('_dateEndFormated', dateEndFormated);
        localStorage.setItem('_statusId', this.currentFilter.statusId.toString());
        localStorage.setItem('_search', this.currentFilter.name);
        localStorage.setItem('_user', this.currentFilter.userId);
        localStorage.setItem('_branch', this.currentFilter.branchId);
        localStorage.setItem('_company', this.currentFilter.companyId);
        localStorage.setItem('f_apikey', this.currentFilter.companyApiKey);

      }
      console.log("Filtro=> ", this.currentFilter);
    } catch (error) {
      console.log(error);
    }
  }

  ngOnInit() {
    localStorage.removeItem("idTransaction");
    localStorage.removeItem("idSectionParent");
    this.currentPage = parseInt(localStorage.getItem('currentPage') ?? this.paginationTableService.resetPageCurrent().toString());

    try {
      this.onCheckFilterSession();
      this.branchId = localStorage.getItem('branchId');
      this.userId = localStorage.getItem('userId');

      this.componentForm = this.fb2.group({
        description: [
          '',
          [
            Validators.required,
            Validators.maxLength(100),
            Validators.pattern(this.regexPattern),
          ],
        ],
      });

      let _statusId = this.currentFilter.statusId;
      let _branch = this.currentFilter.branchId;
      let _user = this.currentFilter.userId;
      let _search = this.currentFilter.name;
      let _company = this.currentFilter.companyId;
      let _companyApiKey = this.currentFilter.companyApiKey;

      let txtDateInit = this.getDateFromString(
        this.currentFilter.dateInitFormated
      );
      let txtDateEnd = this.getDateFromString(
        this.currentFilter.dateEndFormated
      );

      this.fmFilters = this.fb.group({
        ddlCompany: [_company.toString()],
        txtSearch: [_search],
        ddlStatus: [_statusId.toString()],
        ddlBranch: [_branch.toString()],
        txtDateInit: [txtDateInit, [Validators.required]],
        txtDateEnd: [txtDateEnd, [Validators.required]],
      });

      this.loadCompanies();
      setTimeout(() => {
        this.onLoadGrid(false);
      }, 1500);


      let _status_sesion = localStorage.getItem('status_session');
      if (_status_sesion == "403")
        this.onShowAlert();

    } catch (error) {
      console.log('Error: ' + error);
    }
  }

  /** For when the page is closed */
  public ngOnDestroy(): void {
    localStorage.removeItem('currentPage');
    localStorage.removeItem('searchField');
  }

  onLoadGrid(isFilterByUser: boolean) {

    localStorage.setItem('_company', this.currentCompanyId);

    if (isFilterByUser) {
      this.currentPage = this.paginationTableService.resetPageCurrent();
    }

    let dateInit = this.dateInit.value;
    let dateEnd = this.dateEnd.value;

    let dateInitFormated = this.formatDate2(dateInit);
    let dateEndFormated = this.formatDate2(dateEnd);
    this.currentFilter.dateInitFormated = dateInitFormated;
    this.currentFilter.dateEndFormated = dateEndFormated;
    this.currentFilter.branchId = this.fmFilters.get('ddlBranch').value;
    this.currentFilter.statusId = Number.parseInt(this.fmFilters.get('ddlStatus').value);
    this.currentFilter.name = this.fmFilters.get('txtSearch').value;


    localStorage.setItem('_dateInitFormated', dateInitFormated);
    localStorage.setItem('_dateEndFormated', dateEndFormated);
    localStorage.setItem('_statusId', this.currentFilter.statusId.toString());
    localStorage.setItem('_search', this.currentFilter.name);
    localStorage.setItem('_user', this.currentFilter.userId);
    localStorage.setItem('_branch', this.currentFilter.branchId);
    localStorage.setItem('_company', this.currentFilter.companyId);
    localStorage.setItem('f_apikey', this.currentFilter.companyApiKey);

    console.log(this.currentFilter);


    setTimeout(() => {
      this.loadData();
      this.loadData2();
    }, 30);

  }

  loadGraphics(response: any) {
    let status = new Array();
    let success = 0;
    let review = 0;
    let rejected = 0;
    let na = 0;

    response.forEach((element: any) => {
      if (element.status === 1 || element.successManual) success += 1;
      if (element.status === 2 && !element.successManual) review += 1;
      if (element.status === 3 && !element.successManual) rejected += 1;
      if (element.status === 0 && !element.successManual) na += 1;
    });

    status.push(success);
    status.push(review);
    status.push(rejected);
    status.push(na);

    this.dataChart = {
      datasets: [
        {
          data: status,
          backgroundColor: [
            '#7BA300',
            '#FFD900',
            '#FF0000',
            '#22C5DA',
          ],
        },
      ],
    };

    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      borderWidth: 0,
      tooltips: {
        enabled: false,
      },
      plugins: {
        chartAreaBorder: {
          borderColor: 'red',
          borderWidth: 2,
          borderDash: [5, 5],
          borderDashOffset: 2,
        },
      },
    };

  }

  get statusId() {
    return this.fmFilters.get('ddlStatus');
  }
  get search() {
    return this.fmFilters.get('txtSearch');
  }
  get dateInit() {
    return this.fmFilters.get('txtDateInit');
  }
  get dateEnd() {
    return this.fmFilters.get('txtDateEnd');
  }

  loadData(): any {
    this.waitFor = true;
    this.eventService.startLoadingData();

    let statusId = this.statusId.value === '' ? -1 : this.statusId.value;
    let search = this.search.value === '' ? null : this.search.value;
    let dateInit = this.dateInit.value;
    let dateEnd = this.dateEnd.value;

    let dateInitFormated = this.formatDate2(dateInit);
    let dateEndFormated = this.formatDate2(dateEnd);

    let successManual = (statusId === -1) ? null : (statusId == 1);

    try {
      let params = '';
      if (statusId == -1 && search != null) {
        params =
          '&name=' +
          search +
          '&startDate=' +
          dateInitFormated +
          '&endDate=' +
          dateEndFormated;
      } else if (statusId == -1 && search == null) {
        params =
          '&startDate=' + dateInitFormated + '&endDate=' + dateEndFormated;
      } else if (statusId != -1 && search == null) {
        params =
          '&status=' +
          statusId +
          '&successManual=' +
          successManual +
          '&startDate=' +
          dateInitFormated +
          '&endDate=' +
          dateEndFormated;
      } else
        params =
          '&name=' +
          search +
          '&status=' +
          statusId +
          '&successManual=' +
          successManual +
          '&startDate=' +
          dateInitFormated +
          '&endDate=' +
          dateEndFormated;

      let branch = this.fmFilters.get('ddlBranch').value;
      if (branch == '0') {
        branch = '';
      }

      params = params + '&idBranch=' + branch;


      params += '&idCompany=' +
        Number(this.fmFilters.get('ddlCompany').value);

      console.log('Parametros: ', params);

      let currentPageAdjust = (this.currentPage - 1);

      return this.http
        .get<any>(
          '/client/page/' +
          (currentPageAdjust) +
          '?size=' +
          this.rowCount +
          params,
          { observe: 'response' }
        )
        .subscribe(
          (response: any) => {
            console.log("GET=> ", '/client/page/' + currentPageAdjust + '?size=' + this.rowCount + params);
            console.log('RESULTADO CLIENTES:', response.body);
            this.dataInformation = response.body.content;
            this.dataInformationOrigin = response.body.content;
            this.dataInformation.forEach((element: any) => {
              element.check = false;
            });
            this.dataArrayCopy = response.body.content;
            this.eventService.completeLoadingData();
            this.waitFor = false;
            this.totalPages = response.body.totalPages;
            this.totalItems = response.body.totalElements;
            this.resetTable = false;
            localStorage.setItem('isInitLoad', '0');

            this.emptyDataList = response.body.empty;
            this.IsPostBack = true;

            console.log(this.dataInformation);
          },
          (error: Response) => {
            this.eventService.completeLoadingData();
            this.waitFor = false;
            this._errorS.onValidateErrorCode(error);
          }
        );
    } catch {

      if (localStorage.getItem('isInitLoad') == '0') {
        this.eventService.errorMessage(1);
      }

      this.eventService.completeLoadingData();
      this.waitFor = false;
    }
  }

  loadData2(): any {
    this.waitFor = true;
    let statusId = this.statusId.value === '' ? -1 : this.statusId.value;
    let search = this.search.value === '' ? null : this.search.value;
    let dateInit = this.dateInit.value;
    let dateEnd = this.dateEnd.value;

    let dateInitFormated = this.formatDate2(dateInit);
    let dateEndFormated = this.formatDate2(dateEnd);

    let successManual = (statusId === -1) ? null : (statusId == 1);

    try {
      let params = '';
      if (statusId == -1 && search != null) {
        params =
          '&name=' +
          search +
          '&startDate=' +
          dateInitFormated +
          '&endDate=' +
          dateEndFormated;
      } else if (statusId == -1 && search == null) {
        params =
          '&startDate=' + dateInitFormated + '&endDate=' + dateEndFormated;
      } else if (statusId != -1 && search == null) {
        params =
          '&status=' +
          statusId +
          '&successManual=' +
          successManual +
          '&startDate=' +
          dateInitFormated +
          '&endDate=' +
          dateEndFormated;
      } else {
        params =
          '&name=' +
          search +
          '&status=' +
          statusId +
          '&successManual=' +
          successManual +
          '&startDate=' +
          dateInitFormated +
          '&endDate=' +
          dateEndFormated;
      }

      let _branch = this.fmFilters.get('ddlBranch').value;
      if (_branch == '0') {
        _branch = '';
      }

      params = params + '&idBranch=' + _branch;

      params += '&idCompany=' +
        Number(this.fmFilters.get('ddlCompany').value);

      console.log('params', params);
      return this.http
        .get<any>('/client/page/0?size=10000000' + params, {
          observe: 'response',
        })
        .subscribe(
          (response: any) => {
            this.loadGraphics(response.body.content);
          },
          (error: Response) => {
            if (localStorage.getItem('isInitLoad') == '0') {
              console.log("isInitLoad: 0");
            }
            localStorage.setItem('isInitLoad', '0');
            this.waitFor = false;
            console.log(error);

          }
        );
    } catch {
      localStorage.setItem('isInitLoad', '0');
      this.waitFor = false;
    }
  }



  private async getOnTraduction(key: string): Promise<string> {
    return await new Promise((resolve: any) => {
      this.translate.get(key).subscribe((res: string) => {
        resolve(res);
      });
    })
  }


  download() {
    let data = <any>[];
    let _continue = false;

    if (this.dataInformation.length <= 0) return;

    let selectionData = this.dataInformation.filter((x) => x.check);
    if (selectionData.length <= 0) {
      Swal.fire({
        title: '¡No existen clientes seleccionados!',
        text: '¿Desea descargar todos los clientes?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
        cancelButtonColor: Constants.SWEET_ALERT_PROPERTIES.cancelButtonColor,
      }).then((result) => {

        //console.log(this.dataInformation);
        if (result.isConfirmed) {
          this.dataInformation.forEach((element: any) => {
            let statusAux = '';
            if (element.successManual) {
              statusAux = 'Exitoso';
            } else {
              switch (element.status) {
                case 0:
                  statusAux = 'Exitoso';
                  break;
                case 1:
                  statusAux = 'Requiere Validación';
                  break;
                case 2:
                  statusAux = 'Rechazado';
                  break;
                default:
              }
            }
            let aux = {
              Folio: element.id,
              Nombre:
                element.firstName +
                ' ' +
                element.fatherSurname,
              Registro: element.registrationDate,
              Estatus: statusAux,
            };
            data.push(aux);
          });
          this.generateDocument.downloadFile(data, 'Descarga');
        }
      });
    } else {

      //console.log(this.dataInformation);

      this.dataInformation.forEach((element: any) => {
        if (element.check) {
          let statusAux = '';
          if (element.successManual) {
            statusAux = 'Exitoso';
          } else {
            switch (element.status) {
              case 0:
                statusAux = 'Exitoso';
                break;
              case 1:
                statusAux = 'Requiere Validación';
                break;
              case 2:
                statusAux = 'Rechazado';
                break;
              default:
            }
          }
          let aux = {
            Folio: element.id,
            Nombre:
              element.firstName +
              ' ' +
              element.fatherSurname,
            Registro: element.registrationDate,
            Estatus: statusAux,
          };
          data.push(aux);
        }
      });
      console.log("data=>", data);

      this.generateDocument.downloadFile(data, 'Descarga');
    }
  }



  selectAll() {
    this.selectAllCheck = !this.selectAllCheck;

    this.dataInformation.forEach((element: any) => {
      element.check = this.selectAllCheck;
    });
  }

  changeCheck(idUser: any, atuallyStatus: boolean) {
    this.selectAllCheck = false;
    this.dataInformation.forEach((element: any) => {
      if (element.id == idUser) {
        element.check = !atuallyStatus;
      }
    });
  }

  information(id: number, idTransaction: string, idSectionParent: string) {
    localStorage.setItem("idTransaction", idTransaction);
    localStorage.setItem("idSectionParent", idSectionParent);
    this.router.navigate(['/management/document/information/' + id]);
  }

  expedient(id: number, idTransaction: string, idSectionParent: string) {
    localStorage.setItem("idTransaction", idTransaction);
    localStorage.setItem("idSectionParent", idSectionParent);
    this.router.navigate(['/management/document/document/' + id]);
  }

  protected delete(id: number): void {
    Swal.fire({
      title: this.msg_confirmDelete + id + "?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.btnYes,
      denyButtonText: "No",
      cancelButtonText: this.btnCancel,
      confirmButtonColor: Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
      cancelButtonColor: Constants.SWEET_ALERT_PROPERTIES.cancelButtonColor,
    }).then((result) => {
      if (result.value) {
        this.eventService.startLoadingData();

        this.clientService.deleteClient(id.toString()).subscribe({
          next: (response: any) => {
            window.location.reload();
          },
          complete: () => { this.eventService.completeLoadingData(); },
          error: (msg) => {
            this.eventService.completeLoadingData();
            console.log(msg);
            this.translate.stream('common.error500').subscribe((res: string) => {
              this.eventService.errorMessage(0, res);
            });
          }
        });

      }
    })
  }

  removeFilter() {
    localStorage.removeItem('_dateInitFormated');
    localStorage.removeItem('_dateEndFormated');
    localStorage.removeItem('_statusId');
    localStorage.removeItem('_search');
    localStorage.removeItem('_user');
    localStorage.removeItem('_branch');
    localStorage.removeItem('_company');
    window.location.reload();
  }

  loadDataJSON() {
    return new Promise<void>((resolve, reject) => {
      this.httpClient
        .get(this.settingsFile)
        .toPromise()
        .then((response: any) => {
          //console.log(response.listDashboard);
          this.dataResult = response.listDashboard;
          resolve();
        })
        .catch((response: any) => {
          reject(
            `Could not load file '${this.settingsFile}': ${JSON.stringify(
              response
            )}`
          );
        });
    });
  }

  order(column: any) {
    this.dataInformation = this.dataInformationOrigin;
    if (this.ordened == 0) {
      if (column == 1)
        this.dataInformation.sort((a: any, b: any) => b.id - a.id);
      else if (column == 2) {
        this.dataInformation.sort(
          (a: any, b: any) => b.givenName - a.givenName
        );
      }
      this.ordened = 1;
    } else {
      if (column == 1)
        this.dataInformation.sort((a: any, b: any) => a.id - b.id);
      else if (column == 2) {
        this.dataInformation.sort(
          (a: any, b: any) => a.givenName - b.givenName
        );
      }

      this.ordened = 0;
    }
  }

  cleanVariables() {
    this.componentForm.reset();
    this.modalRef.hide();
    this.selectedImageModal = undefined;
  }

  loadUsersForBranch(branchId: any) {

    this.branchId = branchId;
    this.catUsers = [];
    //Se crea un cat con todos

    let valueAll = 'Todos';
    this.translate.stream("common.itemAll").subscribe((res: string) => {
      valueAll = res;
    });

    this.catUsers.push({
      id: 0,
      username: valueAll,
    });



    this.eventService.startLoadingData();

    console.log("BranchId", this.branchId);
    if (this.branchId != '0') {
      this.http.get('/auth/users/branch/'
        + this.branchId + '/'
        + this.currentApiKey
      )
        .subscribe(
          (response: any) => {
            //console.log("BranchId", this.branchId);
            console.log("Usuarios en suc=> ", response);
            response.forEach((element: any) => {
              this.catUsers.push({ id: element.id, username: element.username });
            });

            if ((
              this.currentUser.roles[0].id == EnumUserRol.USER ||
              this.currentUser.roles[0].id == EnumUserRol.RRHH
            ) && this.catUsers.length == 1) {
              this.catUsers.push({
                id: this.currentUser.id,
                username: this.currentUser.username,
              });

            }
            this.eventService.completeLoadingData();

          },
          (error: Response) => {
            console.log(error);
            this.eventService.completeLoadingData();
            this.waitFor = false;
          }
        );
    }
    else {
      this.eventService.completeLoadingData();
    }
  }

  padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
  }

  //YYYY-MM-DD
  public formatDate(date: Date) {
    if (date != null && date.toString() !== '') {
      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join('/');
    } else {
      return null;
    }
  }
  //DD-MM-YYYY
  public formatDate2(date: Date) {
    if (date != null && date.toString() !== '') {
      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/');
    } else {
      return null;
    }
  }

  public getDateFromString(data: string, formatSource: string = 'DD/MM/YYYY') {

    let newDate = new Date();
    if (formatSource == 'YYYY-MM-DD' && data.length >= 10) {
      newDate = new Date(
        data.split('-')[2] + '-' + data.split('-')[1] + '-' + data.split('-')[0]
      );
    }
    if (formatSource == 'DD/MM/YYYY' && data.length >= 10) {
      newDate = new Date(
        data.split('/')[2] + '/' + data.split('/')[1] + '/' + data.split('/')[0]
      );
    }
    return newDate;
  }

  public getDateInitMonth() {
    let currentDate = new Date();
    return new Date(
      currentDate.getFullYear() + '/' + (currentDate.getMonth() + 1) + '/01'
    );
  }


  loadCompanies() {
    this.waitFor = true;
    this.eventService.startLoadingData();
    this.fmFilters.get('ddlCompany').disable();

    this._service.GetCompaniesList().subscribe({
      next: (response: any) => {
        let _resultado = response.body;
        console.log("Compañías=>", _resultado);
        //Llenar el listado inicial
        _resultado.forEach(element => {
          let item: ICatCompany = {
            companyId: element.id,
            companyApiKey: element.apiKey,
            description: element.id + ' - ' + element.name
          };
          this.catCompany.push(item);
        });

        //Mandar el id de la compañía
        this.currentCompanyId = this.currentFilter.companyId;
        this.f['ddlCompany'].setValue(this.currentCompanyId);

        if (this.currentUser.roles[0].id !== EnumUserRol.SUPER_ADMIN) {
          this.fmFilters.get('ddlCompany').disable();
        }
        else {
          this.fmFilters.get('ddlCompany').enable();
        }

        this.eventService.completeLoadingData();
        this.waitFor = false;
        this.loadBranches();
      },
      error: (error: Response) => {
        let _msg = "";
        this.translate.stream("common.errorGetCat").subscribe((res: string) => {
          _msg = res;
        });
        this.eventService.errorMessage(3, _msg);
        console.log(error);
      }
    });
  }

  loadBranches() {
    this.eventService.startLoadingData();
    this.fmFilters.get('ddlBranch').enable();
    let _data = [];
    _data.push({
      id: 0,
      name: '0000 - Todas'
    });

    let url = "";
    if (this.currentUser.roles[0].id !== EnumUserRol.SUPER_ADMIN) {
      url = '/auth/branches?userId=' + this.currentUser.id;
    }
    else {
      url = '/auth/branches/company/' + this.currentApiKey;
    }

    console.log("Sucursales url=>", url);

    this.data = this.http.get(url).subscribe(
      (response: any) => {
        console.log("Sucursales=>", response);

        response.forEach((element: any) => {

          if (element.name.toLowerCase() == "online") {
            _data.push({
              id: element.id,
              name: element.key + ' - ' + element.name + ' ' + element.alias,
            });
          }
          else {
            _data.push({
              id: element.id,
              name: element.key + ' - ' + element.name,
            });

          }

        });
        this.branches = _data;

        if (this.currentUser.roles[0].id == EnumUserRol.SUPER_ADMIN ||
          this.currentUser.roles[0].id == EnumUserRol.ADMIN ||
          this.currentUser.roles[0].id == EnumUserRol.EXECUTIVE) {
          this.f['ddlBranch'].setValue(this.currentFilter.branchId.toString());
          this.fmFilters.get('ddlBranch').enable();
        }
        else {
          this.f['ddlBranch'].setValue(this.currentFilter.branchId.toString());
          this.fmFilters.get('ddlBranch').disable();
        }

        this.eventService.completeLoadingData();
        this.loadUsersForBranch(this.currentFilter.branchId.toString());
      },
      (error: Response) => {
        this.eventService.completeLoadingData();
        this.waitFor = false;
      }
    );

  }

  onChangeCompany(event: any) {

    this.currentCompanyId = event.value;
    let companySelected = this.catCompany.find(x => x.companyId == this.currentCompanyId);
    if (companySelected != undefined) {
      console.log(companySelected);
      console.log("this.currentCompanyId", this.currentCompanyId);
      this.currentApiKey = companySelected.companyApiKey;
      this.currentBranchId = "0";
      this.currentFilter.branchId = "0";
      this.currentFilter.companyApiKey = companySelected.companyApiKey;
      this.currentFilter.companyId = this.currentCompanyId;
      this.loadBranches();
    }
    else {
      this.eventService.warningMessage("Ocurrió un error al obtener la compañía seleccionada, por favor intente de nuevo.");
    }

  }

  onSelectItem(algo: any) {
    console.log(algo);
  }

  onChangeBranch(event: any) {
    this.currentBranchId = event.value;
    this.branchId = event.value;
    localStorage.setItem('_branch', this.branchId);
    this.loadUsersForBranch(event.value);
  }

  onShowAlert() {
    let msg = this.sharedConstants.msg_default_list.find(x => x.message_id == 2).keyLg;
    let _msg = "";
    this.translate.stream(msg).subscribe((res: string) => {
      _msg = res;
    });

    let _textButton = "";
    this.translate.stream("common.btnOk").subscribe((res: string) => {
      _textButton = res;
      Swal.fire({
        text: _msg,
        icon: 'warning',
        confirmButtonText: _textButton,
        customClass: "mdl-session-warning",
        confirmButtonColor:
          Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
      }).then((result) => {
        localStorage.removeItem('status_session');
        console.log(result);
      })
    });
  }


  getASN1(id: string, esFirmado: boolean, documentSignType: string) {

    if (!esFirmado) {
      this.eventService.infoMessage("No ha sido validada la identidad del usuario (" + id + ") en su totalidad, verifique. ");
    }
    else {
      this.waitFor = true;
      this.eventService.startLoadingData();
      try {
        this._contractS.GetASN1Client(id, documentSignType).subscribe({
          next: res => {
            console.log(res);
            let _fileName = "ID-" + id;
            let _utils = new utilsApps();
            let _now = new Date();
            _utils.downloadFileBlob(res, _fileName + _utils.fnDateToString(_now), ".asn1");
            this.eventService.completeLoadingData();
            this.waitFor = false;
          },
          error: error => {
            console.log(error);
            let _errorMsj = "Ha ocurrido un error al intentar descargar los datos. Por favor consulte a su administrador.";
            let _errorKey = 'common.error500_download';

            if (error.status == 500) {
              _errorKey = "common.error500_download_file";
            }
            else if (error.status == 0) {
              _errorKey = "common.error0_download";
            }

            this.translate.stream(_errorKey).subscribe((res: string) => {
              console.log(res);
              _errorMsj = res;
            });

            this.eventService.errorMessage(0, _errorMsj);
            this.eventService.completeLoadingData();
            this.waitFor = false;
          }
        });

      } catch (error) {
        console.log(error);
        this.eventService.completeLoadingData();
        this.waitFor = false;
      }
    }
  }

  protected changePage($event: any): void {
    this.currentPage = $event;
    console.log($event);


    // this.currentPage = parseInt(localStorage.getItem('currentPage') ??
    // $event);

    console.log(this.currentPage);

    setTimeout(() => {
      this.onLoadGrid(false);
    }, 30);
  }

  /**
   * Open modal for admin execute the successful manual acceptation
   * @param idClient ID of register to accept
   */
  protected openManualValidation(idClient: string): void {
    setTimeout(() => {
      this.showModalDialogManualValid = true;
      //Delete all characteres that not are numbers
      const numberString = idClient.replace(/\D/g, '');
      this.idClientManualValid = parseInt(numberString);
    }, 30);
  }
  /**
   * close modal for admin after the successful manual acceptation
   * @param event know if modal is closed or not
   */
  protected closeManualValidation(event: any): void {
    this.showModalDialogManualValid = event;
    this.idClientManualValid = -1;
    setTimeout(() => { this.loadData(); }, 30);
    setTimeout(() => { this.loadData2(); }, 40);
  }


}
